<template>
  <div
    class="mb-2 item"
    v-bind:class="{current: isCurrent}"
    v-bind:style="styles"
    @click="onSelect"
  >
    <div class="d-flex justify-content-between">
            <span class="item-title font-weight-bold">
                <span class="contact" @click.stop="">
                    <span class="filemaker-id" v-if="filemakerId">{{ filemakerId }} </span>
                    <span class="contact-full-name">{{ contactFullName | uppercase }}</span>
                    <span v-if="lastOutgoingMessageHasError">
                      <el-tooltip placement="top" effect="light">
                        <div slot="content">
                          Sending error
                        </div>
                        <span style="color: #FFA500;" class="cursor-pointer">
                          <i class="fas fa-exclamation-circle"></i>
                        </span>
                      </el-tooltip>
                    </span>
                </span>
            </span>
      <span v-if="hasUnread" class="badge badge-danger badge-pill badge-smallest align-self-start mr-2">{{
          unreadCount
        }}</span>
    </div>
    <div class="item-row d-flex justify-content-between">
      <span>
          {{ outgoingNumberTitle | uppercase }}
      </span>
      <span v-if="hasMessages">{{ lastMessageDirectionText | uppercase }}</span>
    </div>
    <div class="item-row d-flex justify-content-between">
            <span>
                ({{ outgoingNumberPhoneNumber | uppercase }})
            </span>
      <span>{{ lastInteraction | uppercase }}</span>
    </div>
  </div>
</template>

<script>
import eventBus from "../../event-bus";

export default {
  props: {
    conversation: Object,
    current: Object,
  },

  data() {
    return {};
  },

  computed: {
    /**
     * @return {Object}
     */
    contact() {
      return _.get(this.conversation, 'contact', {});
    },

    /**
     * @return {string}
     */
    contactFullName() {
      return _.get(this.contact, 'full_name') || '';
    },

    /**
     * @return {Object}
     */
    outgoingNumber() {
      return _.get(this.conversation, 'outgoing_number')
    },

    /**
     * @return {string}
     */
    outgoingNumberTitle() {
      return _.get(this.outgoingNumber, 'title') || '';
    },

    /**
     * @return {string}
     */
    outgoingNumberPhoneNumber() {
      return _.get(this.outgoingNumber, 'phone_number') || '';
    },

    /**
     * @return {Object|null}
     */
    brand() {
      return _.get(this.outgoingNumber, 'brand', null)
    },

    /**
     * @return {String}
     */
    filemakerId() {
      return _.get(this.contact, 'filemaker_id', '');
    },

    /**
     * @return {String}
     */
    messageCount() {
      return this.conversation.message_count || 0;
    },

    /**
     * @return {Boolean}
     */
    hasMessages() {
      return this.messageCount > 0;
    },

    /**
     * @return {Number}
     */
    unreadCount() {
      return this.conversation.unread_count || 0;
    },

    /**
     * @return {Boolean}
     */
    hasUnread() {
      return this.unreadCount > 0;
    },

    /**
     * @return {string}
     */
    lastInteraction() {
      return _.get(this.conversation, 'last_interaction_relative') || '';
    },

    /**
     * @return {string}
     */
    lastMessageDirectionText() {
      return _.get(this.conversation, 'last_message_type_text') || '';
    },

    /**
     * @return {boolean}
     */
    isCurrent() {
      return _.get(this.current, 'id') === this.conversation.id;
    },

    /**
     * @return {Object}
     */
    styles() {
      const {
        'brand.item.text.color': color,
        'brand.item.background.color': backgroundColor
      } = _.get(this.brand, 'styles') || {};

      // remove empty values
      return _.pickBy({color, backgroundColor}, _.identity);
    },

    /**
     * @return {boolean}
     */
    lastOutgoingMessageHasError() {
      return Boolean(_.get(this.conversation, 'last_outgoing_message_error_id'));
    },

    /**
     * @return {*}
     */
    emailContext() {
      return _.get(this.contact, 'email_context', '');
    },
  },

  methods: {
    /**
     * @event conversation-select
     */
    onSelect() {
      this.$emit('conversation-select', this.conversation);
    },

    /**
     * @param {Number} conversationId
     * @return {undefined}
     */
    onMarkUnread(conversationId) {
      if (conversationId === this.conversation.id) {
        this.conversation.unread_count++;

        eventBus.$emit('on-increment-brand-counter', _.get(this.brand, 'id'));
      }
    },
  },

  created() {
    eventBus.$on('on-mark-unread', this.onMarkUnread);
  },

  beforeDestroy() {
    eventBus.$off('on-mark-unread', this.onMarkUnread);
  },
}
</script>
